import React from 'react'
import Footer from './Footer'
import Header from './Header'
import Metadata from './Metadata'

const Layout = ({ children }) => {
  return (
    <div className="overflow-hidden">
      <Metadata />
      <Header />
      <main className="font-secondary text-gray-400">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
